import { IntegrationActionTypes } from "./constants";
import { IntegrationStatus } from "./types";
import { WebhookLog } from "./types";

export interface IntegrationReduxState {
  integrations: IntegrationStatus | null;
  loading: boolean;
  error: string | null;
  webhookLogs: {
    list: WebhookLog[];
    total: number;
    loading: boolean;
    error: string | null;
  };
}

const INIT_STATE: IntegrationReduxState = {
  integrations: null,
  loading: false,
  error: null,
  webhookLogs: {
    list: [],
    total: 0,
    loading: false,
    error: null,
  },
};

export default function integrationReducer(
  state: IntegrationReduxState = INIT_STATE,
  action: any
): IntegrationReduxState {
  switch (action.type) {
    case IntegrationActionTypes.LOAD_INTEGRATION_STATUS:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case IntegrationActionTypes.LOAD_INTEGRATION_STATUS_SUCCESS:
      return {
        ...state,
        integrations: action.payload.data,
        loading: false,
        error: null,
      };

    case IntegrationActionTypes.LOAD_INTEGRATION_STATUS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case IntegrationActionTypes.DISCONNECT_PLATFORM:
      return {
        ...state,
        loading: true,
      };

    case IntegrationActionTypes.DISCONNECT_PLATFORM_SUCCESS:
      return {
        ...state,
        loading: false,
        integrations: state.integrations
          ? { ...state.integrations }
          : null,
      };

    case IntegrationActionTypes.DISCONNECT_PLATFORM_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    case IntegrationActionTypes.SYNC_PRODUCTS:
      return {
        ...state,
        loading: true,
      };

    case IntegrationActionTypes.SYNC_PRODUCTS_SUCCESS:
    case IntegrationActionTypes.SYNC_PRODUCTS_ERROR:
      return {
        ...state,
        loading: false,
      };

    case IntegrationActionTypes.LOAD_WEBHOOK_LOGS:
      return {
        ...state,
        webhookLogs: {
          ...state.webhookLogs,
          loading: true,
          error: null,
        },
      };

    case IntegrationActionTypes.LOAD_WEBHOOK_LOGS_SUCCESS:
      return {
        ...state,
        webhookLogs: {
          list: action.payload.items,
          total: action.payload.total,
          loading: false,
          error: null,
        },
      };

    case IntegrationActionTypes.LOAD_WEBHOOK_LOGS_ERROR:
      return {
        ...state,
        webhookLogs: {
          ...state.webhookLogs,
          loading: false,
          error: action.payload.error,
        },
      };

    default:
      return state;
  }
}
